import { combineReducers } from "redux";
import { UserDetail } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { SEARCH_ASSISTANT_USERS_REQUEST, SEARCH_DOCTOR_USERS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: UserDetail[] = [], action: Action): UserDetail[] {
  switch (action.type) {
    case getSuccessActionType(SEARCH_ASSISTANT_USERS_REQUEST):
    case getSuccessActionType(SEARCH_DOCTOR_USERS_REQUEST):
      return action.payload;
    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case SEARCH_ASSISTANT_USERS_REQUEST:
      return true;
    case getSuccessActionType(SEARCH_ASSISTANT_USERS_REQUEST):
    case getFailureActionType(SEARCH_ASSISTANT_USERS_REQUEST):
    case getSuccessActionType(SEARCH_DOCTOR_USERS_REQUEST):
    case getFailureActionType(SEARCH_DOCTOR_USERS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const searchUser = combineReducers({ items, isFetching });
